export const SET_DONORS_FILTER = 'SET_DONORS_FILTER';

export const SET_LEADS_FILTER = 'SET_LEADS_FILTER';
